export default __webpack_public_path__ + "static/media/select-icon.08b04fe4.svg";